import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide({ flagShow, handleCloseAlert, handleOkAlert, data }) {

  return (
    <div>
      <Dialog
        open={flagShow}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleCloseAlert(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      
      >
        <DialogTitle id="alert-dialog-slide-title"   style={{width:500 , margin:'auto'}}>{data.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {data.description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleOkAlert}
            color="primary">
            بله
          </Button>
          <Button onClick={() => handleCloseAlert(false)} color="primary">
            خیر
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}